import type { ReactElement } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { noRowsOverlayIcon } from "./styles_vanilla.css";
import type { ViewFilter } from "./types";

type NoRowsOverlayProps = {
  viewFilter?: ViewFilter;
  isSystem?: boolean;
};

export const NoRowsOverlay = ({ viewFilter, isSystem }: NoRowsOverlayProps): ReactElement => {
  const isArchived = viewFilter === "archived";

  const getMessage = () => {
    if (isArchived) return "No archived data packages";
    if (isSystem) return "No system data packages";
    return "No custom data packages";
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={SPACING.SMALL}
    >
      <Icon
        type="sitemap"
        size="xx-large"
        color={Colors.Neutral600}
        className={noRowsOverlayIcon}
      />
      <Text variant="h4" align="center" color={Colors.Neutral700}>
        {getMessage()}
      </Text>
      {!isArchived && !isSystem && (
        <Text variant="regular-md" align="center" color={Colors.Neutral700}>
          Start by duplicating an existing data package or creating a new custom hierarchy
        </Text>
      )}
    </Flex>
  );
};
